import type { TileData } from '../../../model/gamestate/GameState';
import type { TerrainTextureKey } from '../../../terrain/registry';
export type { TerrainTextureKey } from '../../../terrain/registry';

export interface TerrainMaterialSet {
  top: {
    color: string;
    textureKey: TerrainTextureKey | null;
    roughness: number;
    metalness: number;
    transparent: boolean;
    opacity: number;
    emissive: string;
    emissiveIntensity: number;
  };
  side: {
    color: string;
    roughness: number;
    metalness: number;
    transparent: boolean;
    opacity: number;
    emissive: string;
    emissiveIntensity: number;
  };
}

export function getTileTerrainTextureKey(tile: TileData): TerrainTextureKey | null {
  if (tile.terrain === 'portal') {
    return null;
  }
  if (tile.biome && tile.biome !== 'default') {
    return tile.biome;
  }
  return null;
}
